// src/apis/shippingApi.ts

import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { 
  PDA1130_R01Dto, 
  PDA1130_R01SearchParams,
  PDA1130_R01DetailDto,
  PDA1130_R01LotDto,
  PDA1130_R01ShipRequest,
} from "../containers/PDA/PDA1130_R01/PDA1130_R01Dto";
import { getData, postData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1130_R01`;

// ========== 목록 화면 API ==========

/**
 * 출하지시 목록 조회
 */
export const getShippingOrders = async (params?: PDA1130_R01SearchParams) => {
  const url = `${baseUrl}`;
  return await getData<ResponseDto<PDA1130_R01Dto[]>>(url, { params });
};

/**
 * 출하지시 목록 조회 (검색)
 */
export const searchShippingOrders = async (params?: PDA1130_R01SearchParams) => {
  const url = `${baseUrl}/search`;
  return await getData<ResponseDto<PDA1130_R01Dto[]>>(url, { params });
};

/**
 * 출하지시 목록 조회 (새로고침)
 */
export const refetchShippingOrders = async (params?: PDA1130_R01SearchParams) => {
  const url = `${baseUrl}/refetch`;
  return await getData<ResponseDto<PDA1130_R01Dto[]>>(url, { params });
};

/**
 * 전체 건수 조회
 */
export const getShippingOrderCount = async (params?: PDA1130_R01SearchParams) => {
  const url = `${baseUrl}/allCount`;
  return await getData<ResponseDto<number>>(url, { params });
};

// ========== 상세 화면 API ==========

/**
 * 출하지시 상세 조회 (출하목록 포함)
 */
export const getShippingDetail = async (orderNo: string) => {
  const url = `${baseUrl}/detail/${orderNo}`;
  return await getData<ResponseDto<PDA1130_R01DetailDto>>(url);
};

/**
 * 품목별 LOT 목록 조회 (v1.1)
 */
export const getLotListByItem = async (itemCd: string, warehouseCd: string) => {
  const url = `${baseUrl}/lot`;
  return await getData<ResponseDto<PDA1130_R01LotDto[]>>(url, { 
    params: { itemCd, warehouseCd } 
  });
};

/**
 * LOT 스캔 및 정보 조회
 */
export const scanLot = async (lotNo: string) => {
  const url = `${baseUrl}/scanLot`;
  return await getData<ResponseDto<PDA1130_R01LotDto>>(url, { 
    params: { lotNo } 
  });
};

/**
 * 제품 출고 일괄 등록 (검수 저장)
 */
export const shipProduct = async (request: PDA1130_R01ShipRequest) => {
  const url = `${baseUrl}/ship`;
  return await postData<PDA1130_R01ShipRequest, ResponseDto<string>>(url, request);
};
